import { hideElement, showElement } from 'utils/toggle_element_visibility'
import { loadTemplate } from "utils/load_template"

class PurchasedItemsFilterWidget {
  template = null
  previousFilters = ''

  constructor(options) {
    this.checkboxId = "purchased_items_filter"
    this.$filterContainer = document.getElementById(options.filterContainerId)
    this.$itemsContainer = document.getElementById(options.itemsContainerId)
    this.purchasedItemsIds = options.purchasedItemsIds
    this.includePurchasedItemsCount = options.includePurchasedItemsCount
    this.filterLabel = options.filterLabel
  }

  getWidgetState(uiState, widgetStateOptions) {
    const searchParameters = widgetStateOptions.searchParameters
    let newState

    if (searchParameters.filters && searchParameters.filters.match(/id\:\d*/)) {
      newState = {
        ...uiState,
        only_purchased: "true"
      }
    } else {
      delete uiState.only_purchased
      newState = uiState
    }

    return newState
  }

  getWidgetSearchParameters(searchParameters, widgetSearchParametersOptions) {
    const uiState = widgetSearchParametersOptions.uiState

    if (!uiState.only_purchased) {
      return searchParameters
    }

    return searchParameters.setQueryParameter("filters", this.buildFiltersWithPurchased(searchParameters.filters))
  }

  render(renderOptions) {
    const { helper, state } = renderOptions
    const purchasedIds = this.purchasedItemsIds

    if (this.isFirstRender()) {
      this.renderFilterStructure(helper, state)
    }

    if (this.includePurchasedItemsCount) {
      this.renderBasedOnRemoteResults(renderOptions, (hits) => {
        const resultsIds = hits.map((ht) => { return ht.id })
        const purchasedInResults = purchasedIds.filter(id => resultsIds.includes(parseInt(id))).length

        if (purchasedInResults > 0) {
          this.$filterContainer.querySelector(".ais-RefinementList-count").textContent = purchasedInResults
          showElement(this.$filterContainer)
          this.$purchasedCheckbox.disabled = false
          this.$purchasedCheckbox.checked = (state.filters && state.filters.match(/id\:\d*/))
        } else {
          this.$filterContainer.querySelector(".ais-RefinementList-count").textContent = 0
          hideElement(this.$filterContainer)
          this.$purchasedCheckbox.disabled = true
        }
      })
    }
  }

  // ATTENTION: We are doing an extra search call to Algolia to return all the results that match the filters
  // so we can calculate how many of those actually include purchased courses. In case of performance degradation
  // this can be disabled by setting the `includePurchasedItemsCount` configuration option to false.
  renderBasedOnRemoteResults(renderOptions, renderFunc) {
    const indexName = renderOptions.state.index
    const index = renderOptions.instantSearchInstance.client.initIndex(indexName)
    const searchProperties = { filters: renderOptions.state.filters }

    const facetFilters = this.buildDisjunctiveFilters(
      renderOptions.state.disjunctiveFacets,
      renderOptions.state.disjunctiveFacetsRefinements
    )

    const hierarchicalFilters = this.buildHierarchicalFilters(
      renderOptions.state.hierarchicalFacets,
      renderOptions.state.hierarchicalFacetsRefinements
    )

    if (facetFilters.length > 0 || hierarchicalFilters.length > 0) {
      searchProperties["facetFilters"] = [...new Set([...facetFilters, ...hierarchicalFilters])]
    }

    index.search(searchProperties).then(({hits}) => {
      renderFunc(hits)
    })
  }

  buildFiltersWithPurchased(previousFilters) {
    const filter = []

    this.purchasedItemsIds.split(',').forEach((id) => {
      filter.push(`id:${id}`)
    })
    return [previousFilters, `(${filter.join(' OR ')})`].filter(fil => !!fil).join(' AND ')
  }

  buildFiltersWithoutPurchased(previousFilters) {
    // We unchecked the purchased filter so we need to remove
    // that condition from the previousFilters in case it was
    // included in the URL e.g. ?purchased=true
    return (previousFilters || '').split(' AND ').filter((fil) => !fil.match(/id\:\d*/)).join(' AND ')
  }

  buildDisjunctiveFilters(facets, refinements) {
    const filters = []

    facets.forEach((df) => {
      if (refinements[df]) {
        filters.push(
          refinements[df].map((val) => { return `${df}:${val}` })
        )
      }
    })

    return filters
  }

  buildHierarchicalFilters(facets, refinements) {
    const filters = []

    facets.forEach((hf) => {
      const refinement = refinements[hf.name]

      if (refinement) {
        const filterString = refinement[0]
        const filterValues = filterString.split(hf.separator)

        hf.attributes.forEach((att, idx) => {
          if (idx < filterValues.length) {
            filters.push(
              `${att}:${filterValues.slice(0, idx + 1).join(hf.separator)}`
            )
          }
        })
      }
    })

    return filters
  }

  isFirstRender() {
    return !this.$filterContainer.querySelector(`#${this.checkboxId}`)
  }

  renderFilterStructure(helper, state) {
    this.template = this.template || loadTemplate("purchased-items-filter-template")
    this.$filterContainer.innerHTML = this.template.interpolateObject({ id: this.checkboxId })
    this.$filterContainer.querySelector(".ais-RefinementList-labelText").textContent = this.filterLabel
    if (!this.includePurchasedItemsCount) {
      hideElement(this.$filterContainer.querySelector(".ais-RefinementList-count"))
    }
    this.setupCheckbox(helper, state.filters)
  }

  setupCheckbox(helper, previousFilters) {
    const _this = this

    this.$purchasedCheckbox = document.getElementById("purchased_items_filter")

    this.$purchasedCheckbox.addEventListener("change", function(evt) {
      if (evt.target.checked) {
        helper.setQueryParameter("filters", _this.buildFiltersWithPurchased(previousFilters))
      } else {
        helper.setQueryParameter("filters", _this.buildFiltersWithoutPurchased(previousFilters))
      }
      helper.search()
    })
  }
}

export default PurchasedItemsFilterWidget
